import axios from 'axios'
import security from '@/services/security.js'

export default {
  listStaffPositions (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/position/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  updateStaffMemberAdminStatus (courseKey, courseScouterId, isAdmin) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/position/' + courseKey + '/admin/' + courseScouterId + '/' + isAdmin, config)
      .then(response => {
        return response.data
      })
  },
  updateStaffMemberFirstTimeStatus (courseKey, courseScouterId, isFirstTime) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/position/' + courseKey + '/admin/' + courseScouterId + '/firsttime/' + isFirstTime, config)
      .then(response => {
        return response.data
      })
  },
  removeCourseStaffPosition (courseKey, courseStaffPositionId) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/position/' + courseKey + '/role/' + courseStaffPositionId, config)
      .then(response => {
        return response.data
      })
  },
  assignStaffMemberToPosition (courseKey, courseStaffPositionId, courseScouterId) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/position/' + courseKey + '/role/' + courseStaffPositionId + '/' + courseScouterId, config)
      .then(response => {
        return response.data
      })
  },
  removeStaffMemberFromPosition (courseKey, courseStaffPositionId) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/position/' + courseKey + '/role/' + courseStaffPositionId, config)
      .then(response => {
        return response.data
      })
  },
  addStaffMemberPosition (courseKey, positionId) {
    const config = { headers: security.getAuthHeader() }
    return axios.post('/position/' + courseKey + '/role/' + positionId, config)
      .then(response => {
        return response.data
      })
  },
  getLeadershipInfo (courseKey, scouterKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/position/' + courseKey + '/leadership/' + scouterKey, config)
      .then(response => {
        return response.data
      })
  }
}
